'use client';

import { FC, useState } from 'react';

import Button from '@/components/ui/Buttons/Button';

import { TypeAccountERCPageTranslations } from '@/utils/translations/types/TypeAccountERCPageTranslations';

import { TypeERCUpcomingBox } from '../../utils';

import { Box } from '../Box';
import { BUTTON_STYLES } from '@/components/ui/Buttons/utils';

export type HiddenUpcomingBoxesProps = {
  t: TypeAccountERCPageTranslations;
  upcomingBoxes: TypeERCUpcomingBox[];
};

const HiddenUpcomingBoxes: FC<HiddenUpcomingBoxesProps> = ({
  t,
  upcomingBoxes,
}) => {
  const [showHiddenUpcomingBoxes, setShowHiddenUpcomingBoxes] = useState(false);

  return (
    <>
      {showHiddenUpcomingBoxes &&
        upcomingBoxes.map((upcomingBox) => (
          <Box
            key={upcomingBox.installmentData.id}
            t={t}
            installmentData={upcomingBox.installmentData}
            productData={upcomingBox.productData}
            isUpcomingBox
          />
        ))}

      <div className="pt-2 px-6 xl:px-0">
        <Button
          classes="w-full xl:w-auto"
          style={BUTTON_STYLES.secondary}
          ctaText={
            showHiddenUpcomingBoxes
              ? t.hideUpcomingBoxes
              : t.loadMoreUpcomingBoxes
          }
          onClick={() => setShowHiddenUpcomingBoxes(!showHiddenUpcomingBoxes)}
        />
      </div>
    </>
  );
};

export default HiddenUpcomingBoxes;
